var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Loader } from "..";
import Text from "../Text";
import { KeyboardEvents } from "../../enums";
import { useDebounce } from "../../hooks";
import React, { useLayoutEffect, useState } from 'react';
import { styled } from "../../utils";
import AutoCompletions, { AutoCompletionsItem } from './AutoCompletions';
import StatelessInput from './StatelessInput';
var AutoCompleteWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var NoOptionsElement = styled.li(function (_a) {
    var fontWeights = _a.theme.fontWeights;
    return ({
        textAlign: 'center',
        pointerEvents: 'none',
        opacity: 0.75,
        fontWeight: fontWeights.medium,
    });
});
var AutoComplete = function (_a) {
    var onSelect = _a.onSelect, action = _a.action, value = _a.value, _b = _a.emptyOptionsLabel, emptyOptionsLabel = _b === void 0 ? 'keine Optionen' : _b, props = __rest(_a, ["onSelect", "action", "value", "emptyOptionsLabel"]);
    var _c = useState(__spreadArray([], ((value === null || value === void 0 ? void 0 : value.name) && (value === null || value === void 0 ? void 0 : value.id) ? [value] : []), true)), options = _c[0], setOptions = _c[1];
    var _d = useState((value === null || value === void 0 ? void 0 : value.name) || ''), query = _d[0], setQuery = _d[1];
    var _e = useState(false), isDropdownOpen = _e[0], setIsDropdownOpen = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(0), focusedElementIndex = _g[0], setFocusedElementIndex = _g[1];
    useLayoutEffect(function () {
        if (value) {
            setQuery(value.name);
        }
    }, [value]);
    var debouncedAction = useDebounce(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!action)
                        return [2];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsLoading(true);
                    return [4, action(value)];
                case 2:
                    result = _a.sent();
                    if (result) {
                        setOptions(result);
                    }
                    setIsDropdownOpen(true);
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    setOptions([]);
                    throw error_1;
                case 4:
                    setIsLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); });
    var handleInputChange = function (_a) {
        var value = _a.target.value;
        setQuery(value);
        if (!value) {
            setOptions([]);
            if (onSelect) {
                onSelect({ name: '', id: '' });
            }
        }
        else {
            debouncedAction(value);
        }
    };
    var handleItemClick = function (selectedOption) {
        if (onSelect) {
            onSelect(selectedOption);
        }
        setIsDropdownOpen(false);
    };
    var handleFocusChange = function (e) {
        if (props.onFocus) {
            props.onFocus(e);
        }
        setIsDropdownOpen(true);
        if (!(options === null || options === void 0 ? void 0 : options.length) && query) {
            debouncedAction(query);
        }
    };
    var handleBlurChange = function (e) {
        if (props.onBlur) {
            props.onBlur(e);
        }
        setIsDropdownOpen(false);
        var searchText = (value === null || value === void 0 ? void 0 : value.name) || '';
        if (searchText === '') {
            setOptions([]);
        }
        setQuery(searchText);
    };
    var handleKeyboardNavigation = function (e) {
        if (isDropdownOpen && isLoading === false) {
            if (e.key === KeyboardEvents.tab || e.key === KeyboardEvents.escape) {
                setIsDropdownOpen(false);
                setOptions([]);
                setQuery('');
            }
            else if (e.key === KeyboardEvents.arrowUp) {
                e.preventDefault();
                var newFocus = focusedElementIndex > 0 ? focusedElementIndex - 1 : focusedElementIndex;
                setFocusedElementIndex(newFocus);
            }
            else if (e.key === KeyboardEvents.arrowDown) {
                e.preventDefault();
                var newFocus = focusedElementIndex < options.length - 1 ? focusedElementIndex + 1 : focusedElementIndex;
                setFocusedElementIndex(newFocus);
            }
            else if (e.key === KeyboardEvents.enter) {
                e.preventDefault();
                setIsDropdownOpen(false);
                var _a = options[focusedElementIndex], name_1 = _a.name, id = _a.id, rest = __rest(_a, ["name", "id"]);
                handleItemClick(__assign({ name: name_1, id: id }, rest));
            }
        }
    };
    var renderItem = function () {
        if (isLoading) {
            return React.createElement(Loader, { tiny: true });
        }
        if (!options.length) {
            return React.createElement(NoOptionsElement, null, emptyOptionsLabel);
        }
        return options.map(function (_a, index) {
            var name = _a.name, id = _a.id, suffix = _a.suffix, rest = __rest(_a, ["name", "id", "suffix"]);
            return (React.createElement(AutoCompletionsItem, { className: focusedElementIndex === index ? 'isFocused' : undefined, key: id, value: name, highlight: query || '', suffix: suffix, onMouseDown: function (e) {
                    e.preventDefault();
                }, onMouseUp: function () {
                    handleItemClick(__assign({ name: name, id: id }, rest));
                } }));
        });
    };
    return (React.createElement(AutoCompleteWrapper, { "data-component": "AutoComplete", onKeyDown: function (e) { return handleKeyboardNavigation(e); } },
        React.createElement(StatelessInput, __assign({}, props, { type: "text", onKeyDown: handleKeyboardNavigation, autoComplete: "off", onChange: handleInputChange, value: query || '', onFocus: handleFocusChange, onBlur: handleBlurChange, elementBelowInput: value.recordDetails && (React.createElement(Text, { fontSize: "tiny", textAlign: "end", color: "lessImportant" }, value.recordDetails)) })),
        React.createElement(AutoCompletions, { isOpen: isDropdownOpen, renderItem: renderItem() })));
};
export default AutoComplete;
var templateObject_1;
//# sourceMappingURL=AutoComplete.js.map